module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-finanzierung-a54119f69b46a95659553bdaf9117f39.svg";